<template>
  <div v-if="giftCardManagementEnabled">
    <modal
      v-slot="{ data }"
      name="giftCardAdd"
      modal-style="compact"
    >
      <gift-card-add :prefill="data.prefill" />
    </modal>

    <modal
      v-slot="{ data }"
      name="giftCardDetails"
      modal-style="compact"
    >
      <gift-card-details :card-id="data.card.cardId" />
    </modal>

    <modal
      v-slot="{ data }"
      name="giftCardMerge"
      modal-style="compact"
    >
      <gift-card-merge :card-id="data.cardId" />
    </modal>

    <modal
      v-slot="{ data }"
      name="giftCardPurchase"
      modal-style="compact"
    >
      <gift-card-purchase
        :card-to-reload="data.cardToReload"
        :override-receipt-navigation="data.overrideReceiptNavigation"
      />
    </modal>

    <modal
      v-slot="{ data: { card } }"
      name="giftCardAutoReload"
      modal-style="compact"
    >
      <gift-card-auto-reload-modal
        :auto-reload="card.autoReload"
        :card-id="card.cardId"
      />
    </modal>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import GiftCardAdd from './gift-card-add/index.vue';
  import GiftCardAutoReloadModal from './gift-card-auto-reload/index.vue';
  import GiftCardDetails from './gift-card-details/index.vue';
  import GiftCardMerge from './gift-card-merge/index.vue';
  import GiftCardPurchase from './gift-card-purchase/index.vue';


  export default {
    name: 'GiftCardManagement',

    components: {
      GiftCardAdd,
      GiftCardAutoReloadModal,
      GiftCardDetails,
      GiftCardMerge,
      GiftCardPurchase
    },

    computed: {
      ...mapGetters('giftCards', ['giftCardManagementEnabled'])
    }
  };
</script>
